<form [formGroup]="dataSearch" class="search_box" >
    <select formControlName="specialityName" id="speciality_search">
    <option value=0 selected>Selecciona especialidad</option>
    <option *ngFor="let speciality of specialities?.specialities" value="{{speciality.id}}">{{ speciality.name }}</option>
    </select>
    <div class="procedure_box inlineflex">
    <input type="text" id="procedure_search" formControlName="procedureName" placeholder="Filtrar por nombre de procedimiento">
    <fa-icon [icon]="faMagnifyingGlass" class="icono tipo-second-color fa-2xl" (click)="getSearch()"></fa-icon>
    </div>
</form> 